<script setup>
import { searchParams as vSearchParams } from '@/composeables/urlSearchParams';

function searchParams(map) {
    Object
        .entries(map)
        .forEach(([key, value]) => {
            vSearchParams[key] = value;
        })
    // window.location = window.location
}
</script>

<template>
    <slot v-bind="{ searchParams }"></slot>
</template>c

<style lang="scss">
@use "@/scss/framework" as *;
</style>
